/**
 * Shared time & calendar formatting helpers for the instructor dashboard.
 * Extracted from InstructorDashboard.js during the Apr 2026 refactor.
 */

// ─── Day window config ───
// NDG-INTENT-CALENDAR-04 · Feb 2026 — the mobile Day view MUST
// show the whole founder working day (07:45–19:45) at once. The
// window is cropped to the operational band (07:00–20:00) and
// PX_PER_MIN is tuned so 13h plus the calendar controls fits in an
// iPhone viewport. Five two-hour cards remain readable; nothing scrolls.
export const DAY_START_H = 7;
export const DAY_END_H = 20;
export const TOTAL_MINUTES = (DAY_END_H - DAY_START_H) * 60; // 780 min
export const PX_PER_MIN = 0.40;
export const TIMELINE_H = TOTAL_MINUTES * PX_PER_MIN; // ≈ 312 px
export const HOUR_LABELS = Array.from(
  { length: DAY_END_H - DAY_START_H + 1 },
  (_, i) => DAY_START_H + i,
);

// ─── Time formatters ───
export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const suffix = h >= 12 ? "pm" : "am";
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return m === 0 ? `${h12}${suffix}` : `${h12}:${String(m).padStart(2, "0")}${suffix}`;
};

export const timeToMin = (t) => {
  if (!t) return 0;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const minToTime = (totalMin) => {
  const clamped = Math.max(DAY_START_H * 60, Math.min(DAY_END_H * 60, totalMin));
  return `${String(Math.floor(clamped / 60)).padStart(2, "0")}:${String(clamped % 60).padStart(2, "0")}`;
};
